
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/paid-advertising-services",
      function () {
        return require("private-next-pages/paid-advertising-services/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/paid-advertising-services"])
      });
    }
  